
import { Injectable } from '@angular/core';
import { AsyncSubject } from 'rxjs';
import { Platform } from '@ionic/angular'; // Please note that @ionic/angular did not work when testing mobile responsive view in browser
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class PlatformService {

    // Internal Cache to speed up the process
    private static isInitialized = false;
    private static _isBrowser = false;
    private static _isMobile = false;
    private static _isIOS = false;
    private static _isAndroid = false;
    private static _isProduction = environment.production;
    private static _platform: Platform;

    constructor(platform: Platform) {
        PlatformService._platform = platform;
    }

    public init(): AsyncSubject<boolean> {

        // Trigger PlatformService.isBrowser to initialize internal variable
        PlatformService.isBrowser();
        PlatformService.isInitialized = true;

        let ret = new AsyncSubject<boolean>();
        ret.next(true);
        ret.complete();
        return ret;
    }

    public static isMobile(): boolean {
        if (this.isInitialized) return this._isMobile;
        this._isMobile = PlatformService.isIOS() || PlatformService.isAndroid();
        return this._isMobile;
    }

    public static isBrowser(): boolean {
        if (this.isInitialized) return this._isBrowser;
        this._isBrowser = !PlatformService.isMobile();
        return this._isBrowser;
    }

    public static isIOS(): boolean {
        if (this.isInitialized) return this._isIOS;
        let url = window.location.href;
        this._isIOS = (url.startsWith("capacitor://mobile.mobilearth.com"));
        return this._isIOS;
    }

    public static isAndroid(): boolean {
        if (this.isInitialized) return this._isAndroid;
        let url = window.location.href;
        this._isAndroid = (url.startsWith("https://mobile.mobilearth.com"));
        return this._isAndroid;
    }

    public static getPlatformSource(): PlatformSource {
        return (PlatformService.isBrowser()) ? PlatformSource.WEB : PlatformSource.APP;
    }

    public static getDeviceType(): string {
        return this.getAppPlatform();
    }

    public static getAppPlatform(): PlatformAppPlatformType {
        if (PlatformService.isIOS()) {
            return PlatformAppPlatformType.IOS;
        } else if (PlatformService.isAndroid()) {
            return PlatformAppPlatformType.AOS;
        } else {
            return PlatformAppPlatformType.WEB;
        }
    }

    public static getPlatform(): Platform {
        return this._platform;
    }

    public static getHeight(): number {
        return this._platform.height();
    }

    public static getWidth(): number {
        return this._platform.width();
    }

    public static isDevelopment(): boolean {
        return !this._isProduction;
    }

    public static isProduction(): boolean {
        return this._isProduction;
    }

}

export enum PlatformSource {
    WEB = "WEB",
    APP = "APP",
}

export enum PlatformAppPlatformType {
    WEB = "Browser",
    AOS = "Android",
    IOS = "iOS"
}